import React from "react"
import { Link, navigate, StaticQuery } from "gatsby"
import PropTypes from "prop-types"
import { withStyles } from "@material-ui/core/styles"
import {
  CssBaseline,
  Container,
  ListItem,
  ListItemText,
  ListItemIcon,
  Select,
  Grid,
  FormControl,
  Backdrop,
  CircularProgress
} from "@material-ui/core"
import "./layout.css"

const useStyles = theme => ({
  formControl: {
    margin: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(.1),
    },
    marginTop: "initial",
    marginBottom: "initial"
  },
  hdrSearchForms: {
    marginTop: 7,
    marginBottom: 7,
    marginRight: 2,
    marginLeft: 2,
    width: '100%',
    position: "absolute",
    '& .MuiInputBase-input': {
      backgroundColor: '#005979',
      fontSize: "1.2rem",
      lineHeight: 1.25,
      [theme.breakpoints.down("sm")]: {
        fontSize: "1rem",
        paddingRight: 10
      },
      // [theme.breakpoints.up("md")]: {
      //   fontSize: ".8rem"
      // },
      // [theme.breakpoints.up("lg")]: {
      //   fontSize: ".8rem"
      // }
      color: '#fff',
      fontFamily: '"uthman"',
      paddingTop: 10,
      paddingBottom: 10,
      borderRadius: 10,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '0',
    },
    '& .MuiSelect-iconOutlined': {
      color: "#fff",
    },
    '&.Mui-focused .MuiInputBase-input option': {
      color: "#005979",
    },
    '& .MuiSelect-select:not([multiple]) option:first-child': {

    },
  },
  readerFormControl: {
    width: "95%",
    position: "relative",
    height: 57,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
    display: "inherit",
  },
  root: {
    width: "100%"
  },
  rtl: {
    direction: "rtl",
    '& .MuiListItem-button': {
      textAlign: "right"
    },
    '& .MuiSelect-iconOutlined': {
      right: "initial",
      left: 2
    },
  },
  breadcrumpsSearchForms: {
    backgroundColor: "#f4f4f4",
    borderRadius: 10,
    '& .MuiBreadcrumbs-ol': {
      color: "green",
      justifyContent: "center",
    }
  },
  headerFormsContainer: {
    marginTop: 20
  },
  headerTitle: {
    textAlign: "center",
    fontSize: "1.3rem",
    color: "#005979",
    '& h1': {
      fontFamily: "palab !important",
      marginBottom: 10,

    },
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }
})

class NavBar extends React.Component {

  constructor(props) {
    super(props);
    this.handlePagesChange = this.handlePagesChange.bind(this);
    this.handlePartsChange = this.handlePartsChange.bind(this);
    this.handleSurahsChange = this.handleSurahsChange.bind(this);
    this.state = {
      openDrop: false
    };
  }

  handlePagesChange(event) {
    this.setState({
      openDrop: true
    })
    navigate('/p/' + event.target.value)
  }

  handlePartsChange(event) {
    this.setState({
      openDrop: true
    })
    navigate('/pr/' + event.target.value)
  }

  handleSurahsChange(event) {
    this.setState({
      openDrop: true
    })
    navigate('/s/' + event.target.value)
  }

  surahsNames(data) {
    const allSurahs = []
    for (const surah of data.allStrapiSurahs.nodes) {
      let mlText = surah.name.filter(x => x.lang.lang === this.props.lang)[0]
      if (mlText) {
        mlText = mlText.text
      } else {
        mlText = this.props.locale['Surah'][this.props.lang] + ' ' + surah.surah_number
      }
      allSurahs.push({
        title: mlText,
        number: surah.surah_number
      })
    }
    return allSurahs
  }

  render() {

    const lang = this.props.lang
    const locale = this.props.locale
    const pageNumber = this.props.pageNumber
    const partNumber = this.props.partNumber
    const surahNumber = this.props.surahNumber
    const allPages = []
    for (let i = 1; i <= 604; i++) {
      allPages[i] = { identifier: locale['Page'][lang], number: i }
    }

    const allParts = []
    for (let i = 1; i <= 30; i++) {
      allParts[i] = { identifier: locale['Part'][lang], number: i }
    }

    const { classes } = this.props;

    function ListItemLink(props) {
      const { icon, primary, to } = props;

      const renderLink = React.useMemo(
        () => React.forwardRef((itemProps, ref) => <Link to={to} ref={ref} {...itemProps} />),
        [to],
      );

      return (
        <ListItem button component={renderLink} divider>
          {icon ? <ListItemIcon>{icon}</ListItemIcon> : null}
          <ListItemText className={classes.drawerListItem} primary={primary} />
        </ListItem>
      );
    }

    ListItemLink.propTypes = {
      icon: PropTypes.element,
      primary: PropTypes.string.isRequired,
      to: PropTypes.string/*.isRequired*/,
    };

    const direction = lang === "ar" ? "rtl" : "ltr"

    return (
      <React.Fragment>
        <CssBaseline />
        <Backdrop className={classes.backdrop} open={this.state.openDrop}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Container
          maxWidth="sm"
          className={classes.headerFormsContainer}
        >
          <div className={classes.headerTitle}><h2 style={{ marginBottom: ".8rem" }}>TECVİDLİ KURAN</h2></div>
          <Grid
            justifyContent="center"
            alignContent="center"
            alignItems="center"
            container
          >
            <Grid md={4} xs={4} item>
              <FormControl
                required
                variant="outlined"
                className={`${classes.formControl} ${classes.readerFormControl}`}
              >
                <Select
                  variant="outlined"
                  className={`${classes[direction]} ${classes.hdrSearchForms}`}
                  native={true}
                  onChange={this.handlePagesChange}
                  value={pageNumber}
                >
                  {allPages.map((option, key) => (
                    <option value={option.number} key={key}>{option.identifier + ' ' + option.number}</option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid md={4} xs={4} item>
              <FormControl
                required
                variant="outlined"
                className={`${classes.formControl} ${classes.readerFormControl}`}
              >
                <StaticQuery
                  query={graphql`
                    query Surahs {
                      allStrapiSurahs {
                        nodes {
                          surah_number
                          name {
                            lang {
                                lang
                            }
                            text
                          }
                        }
                      }
                    }
                  `}
                  render={data => (
                    <Select
                      variant="outlined"
                      className={`${classes[direction]} ${classes.hdrSearchForms}`}
                      native={true}
                      value={surahNumber}
                      onChange={this.handleSurahsChange}
                    >
                      {this.surahsNames(data).map((option, key) => (
                        <option value={option.number} key={key}>{option.title}</option>
                      ))}
                    </Select>

                  )}
                />
              </FormControl>
            </Grid>
            <Grid md={4} xs={4} item>
              <FormControl
                required
                variant="outlined"
                className={`${classes.formControl} ${classes.readerFormControl}`}
              >
                <Select
                  variant="outlined"
                  className={`${classes[direction]} ${classes.hdrSearchForms}`}
                  native={true}
                  onChange={this.handlePartsChange}
                  value={partNumber}
                >
                  {allParts.map((option, key) => (
                    <option value={option.number} key={key}>{option.identifier + ' ' + option.number}</option>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </React.Fragment>
    )

  }
}
export default withStyles(useStyles)(NavBar)